/**
 * Flatten grouped settings API response into a simple key -> { en, ar } map.
 */
import { DEFAULT_CONTACT } from '../constants/contact'
import { SOCIAL_LINKS } from '../constants/social'

export function parseSettingsResponse(responseData, language = 'en') {
  const grouped = responseData?.data || responseData || {}
  const flat = {}

  Object.values(grouped).forEach((group) => {
    if (!group || typeof group !== 'object') return
    Object.entries(group).forEach(([key, value]) => {
      if (value && typeof value === 'object' && ('en' in value || 'ar' in value)) {
        flat[key] = value
        flat[`${key}_en`] = value.en ?? ''
        flat[`${key}_ar`] = value.ar ?? ''
        flat[`${key}_${language}`] = language === 'ar' ? value.ar : value.en
      }
    })
  })

  return {
    ...flat,
    address_en: flat.address_tla_al_ali_en || flat.address_en || 'Amman, Jordan',
    address_ar: flat.address_tla_al_ali_ar || flat.address_ar || 'عمان، الأردن',
    phone: flat.phone_en || flat.phone || DEFAULT_CONTACT.phone,
    fax: flat.fax_en || flat.fax || DEFAULT_CONTACT.fax,
    mobile: flat.mobile_en || flat.mobile || DEFAULT_CONTACT.mobile,
    email: flat.email_en || flat.email || DEFAULT_CONTACT.email,
    american_program_counselor_email:
      flat.american_program_counselor_email_en ||
      flat.american_program_counselor_email ||
      DEFAULT_CONTACT.american_program_counselor_email,
    international_program_director_email:
      flat.international_program_director_email_en ||
      flat.international_program_director_email ||
      DEFAULT_CONTACT.international_program_director_email,
    sadeen_group: flat.sadeen_group_en || flat.sadeen_group || DEFAULT_CONTACT.sadeen_group,
    sadeen_group_ar: flat.sadeen_group_ar || DEFAULT_CONTACT.sadeen_group_ar,
    google_maps_url: flat.google_maps_url_en || flat.google_maps_url || DEFAULT_CONTACT.google_maps_url,
    google_maps_embed_url:
      flat.google_maps_embed_url_en ||
      flat.google_maps_embed_url ||
      DEFAULT_CONTACT.google_maps_embed_url,
    facebook: flat.facebook_url_en || flat.facebook || SOCIAL_LINKS.facebook,
    instagram: flat.instagram_url_en || flat.instagram || SOCIAL_LINKS.instagram,
    twitter: flat.twitter_url_en || flat.linkedin_url_en || flat.twitter || SOCIAL_LINKS.twitter,
    youtube: flat.youtube_url_en || flat.youtube || SOCIAL_LINKS.youtube,
    whatsapp: flat.whatsapp_url_en || flat.whatsapp || SOCIAL_LINKS.whatsapp,
    school_name: flat.school_name_en || flat.school_name || 'Mayar International Schools',
    tagline: flat.tagline_en || flat.tagline || 'Home of the Intellectuals',
  }
}

export function getLocalizedSetting(settings, key, language = 'en') {
  if (!settings) return ''
  const localizedKey = `${key}_${language}`
  if (settings[localizedKey]) return settings[localizedKey]
  const entry = settings[key]
  if (entry && typeof entry === 'object') {
    return language === 'ar' ? entry.ar || entry.en : entry.en || entry.ar
  }
  return settings[`${key}_en`] || settings[key] || ''
}
